// import React from 'react';
// import { useAuth } from '../context/AuthContext';
// import { useNavigate } from 'react-router-dom';

// const RoleBasedPage = ({ pageTitle }) => {
//   const { user, logout } = useAuth();
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     logout();
//     navigate('/login');
//   };

//   return (
//     <div className="p-4 font-sans">
//       <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
//         <div className="flex justify-between items-center mb-6 border-b pb-4">
//           <h1 className="text-3xl font-bold text-gray-800">{pageTitle}</h1>
//           <button
//             onClick={handleLogout}
//             className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-300"
//           >
//             Logout
//           </button>
//         </div>
//         {user && (
//           <div className="space-y-2">
//             <p className="text-gray-700 text-lg"><span className="font-semibold">Welcome,</span> {user.username}</p>
//             <p className="text-gray-600"><span className="font-semibold">User ID:</span> {user.userId}</p>
//             <p className="text-gray-600 capitalize"><span className="font-semibold">Role:</span> {user.role}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const VerifierPage = () => {
//     return <RoleBasedPage pageTitle="Verifier Dashboard" />;
// }

// export default VerifierPage;

import React from "react";
import { useAuth } from "../context/AuthContext.js";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header.jsx";
import { UserCircle } from "lucide-react";

const VerifierPage = () => {
  const { user, logout, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (authLoading) return <div className="text-center p-8">Loading authentication...</div>;
  if (!user) return <div className="text-center p-8">Redirecting to login...</div>;

  // For visual consistency with CollectorPage
  const navItems = [
    { label: "Dashboard", icon: <UserCircle className="w-4 h-4" />, mode: "dashboard" },
  ];

  return (
    <>
      <Header
        user={user}
        onLogout={handleLogout}
        navItems={navItems}
        currentViewMode="dashboard"
        onViewModeChange={() => {}}
        overdueTaskCount={0}
      />
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 font-sans">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-8"> 
      {/* <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 font-sans">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-8 max-w-4xl mx-auto"> */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-6 border-b pb-4">
              Verifier Dashboard
            </h1>

            {user && (
              <div className="space-y-4">
                <p className="text-lg text-gray-700">
                  <span className="font-semibold">Welcome,</span> {user.username}
                </p>
                <p className="text-gray-600">
                  <span className="font-semibold">User ID:</span> {user.userId}
                </p>
                <p className="text-gray-600 capitalize">
                  <span className="font-semibold">Role:</span> {user.role}
                </p>
              </div>
            )}

         
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifierPage;
